import { render } from "./tasksTypes.vue?vue&type=template&id=0f9895a9&scoped=true"
import script from "./tasksTypes.vue?vue&type=script&lang=js"
export * from "./tasksTypes.vue?vue&type=script&lang=js"

import "./tasksTypes.vue?vue&type=style&index=0&id=0f9895a9&lang=less&scoped=true"
import "./tasksTypes.vue?vue&type=style&index=1&id=0f9895a9&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9895a9"]])

export default __exports__